//* 组件属性
import type { NavigationOption } from "../index";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态变量
    const vars = {
        navigations: <NavigationOption[]>[
            { name: i18n.t("Home.Name"), route: { name: "Home" } },
            { name: i18n.t("Toolbox"), route: { name: "Tool" } },
            {
                name: i18n.t("Resource"),
                childrens: [
                    {
                        name: i18n.t("Workflow"),
                        childrens: [
                            { name: i18n.t("MutationAlPredictorFlow"), route: { name: "Workflow" } },
                            { name: i18n.t("GeneMutationFlow"), route: { name: "Variantseek" } },
                        ],
                    },
                    { name: i18n.t("Tutorials"), route: { name: "Tutorials" } },
                    { name: i18n.t("Citations"), route: { name: "Citations" } },
                    { name: i18n.t("Downloads"), route: { name: "Downloads" } },
                ],
            },
            {
                name: i18n.t("News"),
                route: { name: "News" },
                childrens: [
                    { name: i18n.t("GeneticEncyclopedia"), route: { name: "News", params: { type: "genetic" } } },
                    { name: i18n.t("Frontiers"), route: { name: "News", params: { type: "frontier" } } },
                    { name: i18n.t("IndustryInsights"), route: { name: "News", params: { type: "insight" } } },
                    { name: i18n.t("CaseStudies"), route: { name: "News", params: { type: "case" } } },
                ],
            },
            {
                name: i18n.t("AboutUs"),
                childrens: [
                    { name: i18n.t("AboutTheSite"), route: { name: "About" } },
                    { name: i18n.t("ContactUS"), route: { name: "ContactUs" } },
                    { name: i18n.t("PrivacyPolicy"), route: { name: "Privacy" } },
                    { name: i18n.t("UserAgreement"), route: { name: "UserAgreement" } },
                ],
            },
        ],
    };

    //* 响应式变量
    const refs = {
        visible: ref<string | number>(),
    };

    //* 公共类名
    const classify = {
        navigation: "cursor-pointer flex items-center whitespace-nowrap px-[20px] text-[16px] leading-[32px] h-full",
        children: "cursor-pointer block leading-[40px] px-[24px] whitespace-nowrap visited:text-default hover:bg-[#F5F5F5] hover:text-main ",
        three: "cursor-pointer leading-[40px]  whitespace-nowrap visited:text-default hover:underline hover:text-main",
    };

    //* 计算属性
    const computeds = {};

    //* 函数
    const methods = {};
    const handlers = {};
    return { vars, refs, classify, computeds, methods, handlers };
};
